import React from "react";
import { ReviewCard } from "@pages/myPage/_component/index";
import { useParams } from "react-router-dom";

type Props = {
  items: any;
};
const ReviewList = ({ items }: Props) => {
  return (
    <div>
      {items?.map((item: any) => (
        <ReviewCard
          key={item.id}
          nickname={item.nickname}
          product_image={item.product_image}
          product_name_ko={item.product_name_ko}
          product_name_en={item.product_name_en}
          rate={item.rate}
          product_total_count={item.total_product_count}
          created_at={item.created_at}
          review_text={item.review_text}
        />
      ))}
    </div>
  );
};

export default ReviewList;
